<!--Copyright (C) nexleader - All Rights Reserved-->
<!--Unauthorized copying of this file, via any medium is strictly prohibited-->
<!--Proprietary and confidential-->
<!--Written for nexleader <myipsat.com>, 2016-2026-->

<div class="modal-header">
  <h3 class="modal-title">Your Identity Statements (with Archetype Lens)</h3>
  <button type="button" class="close" aria-label="Close" (click)="close()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body" *ngIf="statements.length > 0">
  <p class="text-muted m-b-md">
    Your five self-authored identity statements, each viewed through the lens
    of your primary archetype pattern.
  </p>

  <!-- 2-column table layout per Steve's 2026-06-05 mockup: statement type on -->
  <!-- the left, the user's quote + archetype lens on the right. -->
  <table class="table">
    <tbody>
      <tr *ngFor="let s of statements">
        <td class="font-bold text-primary-2" style="width: 25%; vertical-align: top; padding: 14px 16px;">
          {{ s.statement_type }}
        </td>
        <td style="vertical-align: top; padding: 14px 16px;">
          <p class="m-b-xs">&ldquo;{{ s.statement_text }}&rdquo;</p>
          <p class="m-b-none font-italic text-primary-2" *ngIf="s.archetype_lens">
            <strong>Archetype Lens:</strong>&nbsp;{{ s.archetype_lens }}
          </p>
          <p class="m-b-none text-muted" *ngIf="!s.archetype_lens">
            <i class="fa fa-magic"></i>&nbsp;&nbsp;<em>Archetype lens still generating…</em>
          </p>
        </td>
      </tr>
    </tbody>
  </table>
</div>

<div class="modal-body text-center" *ngIf="statements.length === 0">
  <i class="fa fa-magic fa-2x text-muted m-b-sm"></i>
  <h5 class="text-muted">Your archetype-lensed statements are still generating</h5>
  <p class="text-muted">
    If you just purchased your report, check back in a moment.
  </p>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-success" (click)="close()">Close</button>
</div>
